(() => {
  const audio = document.getElementById('fk-site-music');
  const toggle = document.getElementById('fk-music-toggle');
  if (!audio || !toggle || audio.dataset.initialized) return;
  audio.dataset.initialized = 'true';
  // "Start at" (Theme settings → Music): "45", "0:45" or "1:02:05"; anything else means the top of the song
  const parseStart = (v) => {
    const parts = String(v || '').trim().split(':');
    if (!parts[0]) return 0;
    const nums = parts.map(Number);
    return nums.every((n) => Number.isFinite(n) && n >= 0) ? nums.reduce((t, n) => t * 60 + n, 0) : 0;
  };
  const startAt = parseStart(audio.dataset.start);
  const song = audio.getAttribute('src');
  const key = 'fk-music-v2';
  let state = {};
  try { state = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (_) {}
  if (state.src !== song) state = {muted: state.muted};   // a new song starts from its start point, not the old song's spot
  let muted = state.muted === true;
  audio.muted = muted;
  const update = () => {
    toggle.textContent = muted ? 'Sound off' : 'Sound on';
    toggle.setAttribute('aria-label', muted ? 'Unmute music' : 'Mute music');
    toggle.setAttribute('aria-pressed', String(muted));
    toggle.hidden = !muted && audio.paused;
  };
  const save = () => {
    try { sessionStorage.setItem(key, JSON.stringify({src: song, time: audio.currentTime, muted})); } catch (_) {}
  };
  const from = () => (Number.isFinite(audio.duration) && audio.duration > 0 ? Math.min(startAt, Math.max(0, audio.duration - 1)) : startAt);
  const resume = () => {
    const t = Number.isFinite(state.time) && state.time > from() && state.time < audio.duration ? state.time : from();
    audio.currentTime = t;
  };
  if (audio.readyState >= 1) resume();
  else audio.addEventListener('loadedmetadata', resume, {once: true});
  // loop back to the start point, not the top of the file
  audio.addEventListener('ended', () => { audio.currentTime = from(); audio.play().catch(() => {}); });
  const start = () => {
    if (audio.paused && !muted) audio.play().then(update).catch(() => {});
  };
  document.addEventListener('click', start);
  document.addEventListener('touchend', start, {passive: true});
  document.addEventListener('keydown', start);
  toggle.addEventListener('click', event => {
    event.stopPropagation();
    muted = !muted;
    audio.muted = muted;
    if (!muted) start();
    update(); save();
  });
  let lastSave = 0;
  audio.addEventListener('timeupdate', () => {
    if (Date.now() - lastSave > 1000) { save(); lastSave = Date.now(); }
  });
  audio.addEventListener('playing', update);
  // Instagram's (and TikTok's) in-app browser keeps the page alive after the shopper closes it, so the music kept
  // playing (Gibbs 2026-10-31). Stop whenever the page is hidden, closed, frozen or loses focus; pick it back up
  // only if it was playing when they come back. Those browsers don't reliably send any ONE of these, so listen to all.
  let resumeOnShow = false;
  const stop = () => {
    if (!audio.paused) { resumeOnShow = true; audio.pause(); }
    save();
  };
  const back = () => {
    if (resumeOnShow && !document.hidden) { resumeOnShow = false; start(); }
  };
  window.addEventListener('pagehide', stop);
  document.addEventListener('freeze', stop);
  document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else back(); });
  window.addEventListener('blur', () => {
    // focus moving INTO the page (e.g. the Omnisend form's iframe) is not leaving it
    setTimeout(() => { const a = document.activeElement; if (!(a && a.tagName === 'IFRAME')) stop(); }, 0);
  });
  window.addEventListener('focus', back);
  window.addEventListener('pageshow', () => { if (!document.hidden) start(); });
  update(); start();
})();
